import deburr from 'lodash/deburr'

export const searchString = (value: string, search: string) => {
  return deburr(value).toLowerCase().includes(deburr(search).toLowerCase())
}
